import { CrownTargetModel } from './../../shared/models/crown-target';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';


@Component({
  selector: 'app-list-crown-target',
  templateUrl: './list-crown-target.component.html',
  styleUrls: ['./list-crown-target.component.scss']
})
export class ListCrownTargetComponent implements OnInit {

  crownTargets: CrownTargetModel[];
  getPaginationCount = 0;
  page = 1;
  campaigns;
  quizTypes: any;
  resetDropdown: boolean;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    public adminDataProvider: AdminDataProvider,
    private formateDate: DateFormateService,
    public alertService: AlertService
  ) {

  }

  ngOnInit() {
    this.getCrownTargets();
  }


  redirectToTaskAddAndEdit(data) {
    this.router.navigate(["/", "hubAdmin", "add-crown-target", data.id]);
  }

  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getCrownTargets();
  }

  getCrownTargets() {
    this.apiService
      .getHeaders(
        this.apiConfig.getCrownTargetList +
        "?page=" +
        this.page
      )
      .subscribe(
        (res: any) => {
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          this.crownTargets = res.body.data;
          if (this.crownTargets.length > 0) {
            this.crownTargets.forEach(c => {
              c.show = false;
              c.statusString = (c.status == 1) ? "Active" : (c.status == 2) ? "Completed" : "Inactive";
              if (new Date(c.start_date) >= new Date()) {
                c.show = true;
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }


  changeStatus(item: any) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateCrownTarget + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
        this.getCrownTargets();
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
